import { createSelector } from '@ngrx/store';

import { getMenuFlowDetailsByWizzard } from '../getMenuFlowDetailsByWizzard';

export const getMenuFlowDetailsPagesByWizzard = createSelector(getMenuFlowDetailsByWizzard, (menuFlow) => {
    if (!menuFlow) return null;

    return menuFlow.Pages;
});
